// extracted by mini-css-extract-plugin
module.exports = {"item":"ykVxqu","title":"q_calH"};